import { ChangeDetectorRef, Component } from '@angular/core';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { UserInfoService } from '../../spartacus/services/user-info.service';

@Component({
  selector: 'app-uptakelanding',
  standalone: false,
  templateUrl: './uptakelanding.component.html',
  styleUrls: ['./uptakelanding.component.scss']
})

export class UptakelandingComponent {
  landingcontent:any;
  screenvalue:number=999;
  landingtext: Observable<any> = this.component.data$;
  constructor(private userInfoService:UserInfoService,protected config: OccConfig,public component: CmsComponentData<CmsBannerComponent>,private cdr: ChangeDetectorRef ) {

  }
  
  ngOnInit() {
    this.landingtext.subscribe((res: any) => {
      this.landingcontent=res;
      this.cdr.detectChanges();
    });
    this.userInfoService.getuptake().subscribe((value:any)=>{
      this.screenvalue=value
      this.cdr.detectChanges()
      });
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  getImage(image: any): string {
    return this.config.backend?.occ?.baseUrl + image?.url;
  }
  navigatetodetails(value:number){
    this.userInfoService.setuptake(value);
    this.scrollToTop();
  }

  ngOnDestroy(){
    this.userInfoService.setuptake(999);
  }
  
}
